import React from 'react'

import Image from '@/components/image/image'
import Link from '@/components/link/link'

import * as styles from './header-background-v3.module.scss'

type HeaderImageProps = {
  title: string | null
  topic: Queries.TopicReferenceFragment | null
  image:
    | {
        readonly gatsbyImageData: Record<string, unknown> | null
        readonly alt: string | null
      }
    | null
    | undefined
    | Record<string, unknown>
}

const HeaderBackgroundV3: React.FC<HeaderImageProps> = ({
  title,
  topic,
  image
}) => {
  return (
    <div className={styles.header}>
      <div className={styles.bgImage}>
        <Image image={image} />
      </div>
      <div className={`container ${styles.containerHeader}`}>
        <div className="row">
          <div className="col-lg-10">
            {topic && (
              <div className={styles.topic}>
                <Link to={`/topic/${topic.slug}`}>{topic.externalName} /</Link>
              </div>
            )}
            <h1>{title}</h1>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderBackgroundV3
